// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"852":"06c1834e","976":"d65578c6","997":"feed18be"}[chunkId] + ".chunk.js";
};